<template>
    <div class="main">
        <component-header :headerdata="headerdata"></component-header>
        <div class="pager">
            <div class="container" style="text-align: left; margin: 0.1em; margin-top: -0.2em;">
                <div class="card">
                    <div class="card card-box-fl">
                        <h4>
                            <a class="card-link" href="/manage/items/settings/resetcategory">
                                Move to new Category
                                <span style="float: right; font-size: 18px;"><i class="fas fa-angle-right"></i></span>
                            </a>
                        </h4>
                        <div style="clear: both;"></div>
                    </div>
                    <div class="card card-box-fl">
                        <h4>
                            <a class="card-link" href="/manage/items/settings/addtocategories">
                                Add to new Categories
                                <span style="float: right; font-size: 18px;"><i class="fas fa-angle-right"></i></span>
                            </a>
                        </h4>
                        <div style="clear: both;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .card-box-fl{
        margin-bottom: 2em;
    }
</style>

<script>
//import services from './../../../services/service'; 
import AccountResources from './../../Account/Resources/commonfunctions.js';
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

//
//let service = new services();

export default {
    name: "ResetCategory",
    mixins: [AccountResources],
    data() {
        return {
            headerdata:{
                'name':'Reset Category',
            },
        }
    },
  
    
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
    },

    methods: {
    
    },

    mounted: function(){
        
    },

    created: function() {
        // if(this.$route.params.item && (Object.keys(this.$route.params.item).length > 0)){
        //     this.product = this.$route.params.item;
        // }else{
        //     this.$router.push('/manage/items')
        // }
    }
}
</script>



// WEBPACK FOOTER //
// ResetCategory.vue?017eca66